import type { ReactNode } from 'react'
import { Icon, type IconName, isIconName } from '../icon/index.ts'

export const SelectOptionIcon = ({ icon }: { icon: IconName | ReactNode }) => {
  return isIconName(icon) ? <Icon name={icon} size="md" color="info" /> : icon
}
